import type { ChangeEvent, CSSProperties } from "react";

interface Props {
  value: string;
  onChange: (next: string) => void;
  onClear: () => void;
  placeholder?: string;
}

export default function SearchBar({ value, onChange, onClear, placeholder }: Props) {
  return (
    <div style={styles.wrap}>
      <span style={styles.icon}>⌕</span>
      <input
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        placeholder={placeholder ?? "Search next drink…"}
        style={styles.input}
        autoComplete="off"
        spellCheck={false}
      />
      {value.length > 0 && (
        <button
          type="button"
          onClick={onClear}
          style={styles.clear}
          aria-label="Clear search"
        >
          ✕
        </button>
      )}
    </div>
  );
}

const styles: Record<string, CSSProperties> = {
  wrap: { position: "relative", flex: 1 },
  icon: {
    position: "absolute",
    left: 12,
    top: "50%",
    transform: "translateY(-50%)",
    color: "var(--muted)",
    fontSize: 16,
    pointerEvents: "none",
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    height: 40,
    borderRadius: 12,
    border: "1px solid var(--border)",
    background: "var(--surface)",
    color: "var(--text)",
    padding: "0 36px 0 34px",
    outline: "none",
    fontSize: 16,
    fontWeight: 700,
  },
  clear: {
    position: "absolute",
    right: 8,
    top: "50%",
    transform: "translateY(-50%)",
    width: 24,
    height: 24,
    borderRadius: 12,
    border: 0,
    background: "var(--border)",
    color: "var(--text)",
    fontSize: 11,
    fontWeight: 800,
    cursor: "pointer",
  },
};
